import { render, staticRenderFns } from "./centerBranch.vue?vue&type=template&id=79a73b0a&"
import script from "./centerBranch.vue?vue&type=script&lang=js&"
export * from "./centerBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports